module.exports = __webpack_public_path__ + "static/media/attach.b08b5ecd.svg";